import { makeAutoObservable } from 'mobx';
import { IValidatedInputLibrary } from '../IValidatedInputLibrary';

export class CheckInputLibrary implements IValidatedInputLibrary
{
	constructor(isRequired: () => boolean, onChange?: (value: boolean | undefined)=>void)
	{
		this.IsRequired = isRequired;
		this.OnChange = onChange;

		makeAutoObservable(this, {}, { autoBind: true });
	}

	/** Содержимое поля ввода */
	public Value: boolean | undefined = undefined;
	public setValue(value: boolean | undefined)
	{
		const oldValue = this.Value;
		this.Value = value;
		if (oldValue !== value && this.OnChange) this.OnChange(value);
	}

	/** Валидность поля ввода */
	public IsValid: boolean = true;
	public setIsValid(value: boolean) { this.IsValid = value; }

	/** Необходимость поля ввода */
	public IsRequired: () => boolean;

	/** Событие изменения значения */
	public OnChange: ((value: boolean | undefined) => void) | undefined;

	/** Доступность поля ввода */
	public IsDisabled: boolean = false;
	public setIsDisabled(value: boolean) { this.IsDisabled = value; }

	/** Валидация */
	public Validate(onlyCheck?:boolean): boolean
	{
		if (this.IsDisabled)
		{
			if (onlyCheck) return true;
			this.IsValid = true;
			return this.IsValid;
		}

		if (this.Value === undefined || this.Value === false)
		{
			if (this.IsRequired())
			{
				if (onlyCheck) return false;
				this.IsValid = false;
				return this.IsValid;
			}
		}

		if (onlyCheck) return true;
		this.IsValid = true;
		return this.IsValid;
	}
}
